"use client";

import React, { useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";
export default function HeroSection() {
  const widgetRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const tryRender = () => {
      if (typeof (window as any).renderPortableSearchBar === 'function') {
        (window as any).renderPortableSearchBar();
      }
    };

    // Tentative immédiate
    tryRender();

    // Fallback Safari : retry après 500ms et 1500ms
    const t1 = setTimeout(tryRender, 500);
    const t2 = setTimeout(tryRender, 1500);
    const existingScript = document.getElementById('lodgify-psb-script');
    if (existingScript) {
      existingScript.addEventListener('load', tryRender);
      return () => {
        existingScript.removeEventListener('load', tryRender);
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);
  return <section id="le-luxe-sauvage" className="relative w-full min-h-screen flex flex-col items-center justify-start text-foreground overflow-hidden bg-background font-default pb-24 md:pb-0">
      <style>{`
        :root {
          --ldg-psb-background: #ffffff;
          --ldg-psb-border-radius: 0px;
          --ldg-psb-box-shadow: 0px 24px 54px 0px rgba(0, 0, 0, 0.3);
          --ldg-psb-padding: 16px;
          --ldg-psb-input-background: #ffffff;
          --ldg-psb-button-border-radius: 0px;
          --ldg-psb-color-primary: #fac600;
          --ldg-psb-color-primary-lighter: #fde380;
          --ldg-psb-color-primary-darker: #7d6300;
          --ldg-psb-color-primary-contrast: #333333;
          --ldg-component-modal-z-index: 9999;
        }
        #lodgify-search-bar { width: 100%; }

        @media (max-width: 767px) {
          #lodgify-search-bar [class*="dates-container"],
          #lodgify-search-bar [class*="InputsContainer"] {
            flex-direction: column !important;
            gap: 12px !important;
          }
          #lodgify-search-bar [class*="date-input"],
          #lodgify-search-bar [class*="InputWrapper"],
          #lodgify-search-bar input {
            width: 100% !important;
            max-width: 100% !important;
          }
          #lodgify-search-bar [class*="separator"],
          #lodgify-search-bar [class*="Divider"] {
            display: none !important;
          }
        }

        @keyframes lbd-fadein {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        .lbd-hero-bg {
          animation: lbd-fadein 1s ease forwards;
        }
        .lbd-title {
          opacity: 0;
          animation: lbd-fadein 2s ease forwards;
          animation-delay: 500ms;
          background: linear-gradient(to bottom, hsl(210, 4%, 9%) 0%, hsla(210, 4%, 9%, 0.4) 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
        }
        .lbd-heading {
          opacity: 0;
          animation: lbd-fadein 2s ease forwards;
          animation-delay: 1000ms;
          background: linear-gradient(to bottom, hsl(210, 4%, 9%) 0%, hsla(210, 4%, 9%, 0.4) 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
        }
        .lbd-scroll {
          opacity: 0;
          animation: lbd-fadein 1s ease forwards;
          animation-delay: 2000ms;
        }
.lbd-cta-wrapper {
  position: relative;
  width: 90%;
  max-width: 1000px;
  display: flex;
  justify-content: center;
  padding: 0 16px;
  margin-top: 24px;
  z-index: 40;
}

@media (min-width: 768px) {
  .lbd-cta-wrapper {
    position: absolute;
    top: 60%;
    bottom: auto;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0;
    margin-top: 0;
    width: 90%;
  }
}
`}</style>
      
      {/* IMAGE DE FOND */}
      <div className="lbd-hero-bg absolute inset-0 w-full h-full bg-cover bg-bottom bg-no-repeat z-0" style={{
      backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627813/img/image_0fywssed.png')"
    }} aria-hidden="true" />

      {/*  DEGRADÉ DE TRANSITION (REMPLACE L'ANCIEN OVERLAY) */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-[#141414] z-10 pointer-events-none" aria-hidden="true" />

      {/* TITRES */}
      <div className="relative z-20 flex flex-col items-center md:items-start w-full max-w-7xl pt-[16vh] md:pt-[15vh] px-8 md:px-16">
        <h1 className="lbd-title uppercase tracking-[0.15em] leading-none font-bold m-0 max-md:mb-[15px] text-[5vw] !text-center !w-[1152px] md:text-lg">LOGEMENTS À PORT-MENIER</h1>
        <h2 className="lbd-heading uppercase font-extrabold tracking-tighter leading-[0.9] relative !p-0 ![margin:16px_0px_0px_0px] text-[15vw] w-full !text-center md:text-[175px] md:font-bold">
          LES BRISES D'ANTICOSTI
        </h2>
      </div>
    
      {/* WIDGET LODGIFY */}
      <div className="lbd-cta-wrapper">
        <div ref={widgetRef} id="lodgify-search-bar" data-website-id="646480" data-language-code="fr" data-search-page-url="https://brises-anticosti.lodgify.com/fr/toutes-les-proprietes" data-dates-check-in-label="Arrivée" data-dates-check-out-label="Départ" data-guests-counter-label="Invités" data-guests-input-singular-label="{{NumberOfGuests}} invité" data-guests-input-plural-label="{{NumberOfGuests}} invités" data-location-input-label="Emplacement" data-search-button-label="Rechercher" data-dates-input-min-stay-tooltip-text='{"one":"Minimum {minStay} nuit","other":"Minimum de {minStay} nuits"}' data-guests-breakdown-label="Invités" data-adults-label='{"one":"adulte","other":"adultes"}' data-adults-description="Âges {minAge} ou plus" data-children-label='{"one":"enfant","other":"enfants"}' data-children-description="Âges {minAge} - {maxAge}" data-children-not-allowed-label="Non adapté aux enfants" data-infants-label='{"one":"bébé","other":"bébés"}' data-infants-description="Moins de {maxAge}" data-infants-not-allowed-label="Non adapté aux bébés" data-pets-label='{"one":"animal de compagnie","other":"animaux de compagnie"}' data-pets-not-allowed-label="Non autorisé" data-done-label="Terminé" data-new-tab="false" data-version="stable" data-has-guests-breakdown></div>
      </div>

      {/* SCROLL INDICATOR */}
      <div className="lbd-scroll absolute bottom-6 left-8 md:left-16 z-20 hidden sm:flex flex-col items-start gap-2 opacity-70">
        <span className="text-[hsl(210,4%,9%)] font-default text-[10px] tracking-widest uppercase">
          SCROLL
        </span>
        <ChevronDown className="text-[hsl(210,4%,9%)] w-5 h-5" />
      </div>

    </section>;
}